import { addLocaleData } from 'react-intl';
import * as locale_de from 'react-intl/locale-data/de';
import * as locale_el from 'react-intl/locale-data/el';
import * as locale_en from 'react-intl/locale-data/en';
import * as locale_es from 'react-intl/locale-data/es';
import * as locale_fr from 'react-intl/locale-data/fr';
import * as locale_it from 'react-intl/locale-data/it';
import * as locale_ja from 'react-intl/locale-data/ja';
import * as locale_pl from 'react-intl/locale-data/pl';
import * as locale_pt from 'react-intl/locale-data/pt';
import * as locale_th from 'react-intl/locale-data/th';
import * as locale_zh from 'react-intl/locale-data/zh';
import translations_de from './de.json';
import translations_el from './el.json';
import translations_en from './en.json';
import translations_es from './es.json';
import translations_fr_CA from './fr_CA.json';
import translations_fr_FR from './fr_FR.json';
import translations_it from './it.json';
import translations_ja from './ja.json';
import translations_pl from './pl.json';
import translations_pt from './pt.json';
import translations_th from './th.json';
import translations_zh from './zh.json';

export const translations = {
    de: translations_de, el: translations_el, en: translations_en, es: translations_es, "fr-FR": translations_fr_FR, "fr-CA": translations_fr_CA,
    it: translations_it, ja: translations_ja, pl: translations_pl, pt: translations_pt, th: translations_th, zh: translations_zh
};

export function addLocales() {
    addLocaleData([...locale_de, ...locale_el, ...locale_en, ...locale_es, ...locale_fr, ...locale_it, ...locale_ja, ...locale_pl, ...locale_pt, ...locale_th, ...locale_zh]);
}




// WEBPACK FOOTER //
// ./src/i18n/i18n.util.ts